import axios from "axios";
import { SET_SIGNATURE,SET_NONCE } from "./types";

export const setSignature = (signature) => {
  return (dispatch) => {
    dispatch({
      type: SET_SIGNATURE,
      payload: signature,
    });
    localStorage.setItem('signature', signature);

  };
};
export const setNonce = (nonce) => {
  return (dispatch) => {
    dispatch({
      type: SET_NONCE,
      payload: nonce,
    });
  };
};